import { ChildrenType } from "modules/contentRepository/types";
import SectionTypeForm from "./SectionTypeForm";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Step } from "UIKit";

interface useSectionTypeStepProps {
  onSubmit: (childrenType: ChildrenType) => void;
  onPrev: () => void;
}

export const useSectionTypeStep = ({ onSubmit, onPrev }: useSectionTypeStepProps): Step<"type"> => {
  const { t } = useTranslation();
  const [childrenType, setChildrenType] = useState<ChildrenType>("section");

  const handleSubmitSectionType = () => {
    onSubmit(childrenType);
  };

  const handleChangeAccessType = (childrenType: ChildrenType) => {
    setChildrenType(childrenType);
  };

  return {
    name: "type",
    title: t("create_section_type_step_title"),
    component: (
      <SectionTypeForm onChangeSectionType={handleChangeAccessType} selectedType={childrenType} />
    ),
    onSubmit: handleSubmitSectionType,
    backLabel: t("general_cancel"),
    onPrev,
  };
};
